import {
  Directive,
  EmbeddedViewRef,
  Input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { AccessService } from './access.service';
import { Permission } from './permissions';

export type PermissionCheckMode = 'all' | 'any';

@Directive({
  selector: '[appHasPermission]',
})
export class HasPermissionDirective implements OnDestroy {
  private permissions: readonly Permission[] = [];
  private mode: PermissionCheckMode = 'all';

  private view: EmbeddedViewRef<unknown> | null = null;

  private readonly accessSubscription: Subscription;

  constructor(
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly accessService: AccessService
  ) {
    this.accessSubscription = this.accessService.access$.subscribe(() => {
      this.render();
    });
  }

  @Input()
  set appHasPermission(value: Permission | readonly Permission[],) {
    this.permissions = typeof value === 'string' ? [value] : value;

    this.render();
  }

  @Input()
  set appHasPermissionMode(value: PermissionCheckMode) {
    this.mode = value ?? 'all';
    this.render();
  }

  ngOnDestroy(): void {
    this.accessSubscription.unsubscribe();
  }

  private render(): void {
    const allowed =
      this.permissions.length === 0 ||
      (this.mode === 'any'
        ? this.accessService.hasAny(this.permissions)
        : this.accessService.hasAll(this.permissions));

    if (allowed && this.view === null) {
      this.view = this.viewContainer.createEmbeddedView(this.templateRef);

      return;
    }

    if (!allowed && this.view !== null) {
      this.viewContainer.clear();
      this.view = null;
    }
  }
}
